import {
  Box
} from '@material-ui/core';
import React, { useState } from "react";
import ProductFields from './ProductFields';
import SearchField from './SearchField';
import TableProductsVirtual from './TableProductsVirtual';
import HeaderVirt from './headerVirt';

const PageVirtualComplect = () => {
  const [products, setProducts] = useState([]);
  const [stateFields, setStateFields] = useState<null | object>(null);
  const [photos, setPhotos] = useState([]);

  const onEmitProduct = (product: any) => {
    setProducts([...products, product]);
  }

  const onEmitCount = (product: any) => {
    let newProducts = products.map(element => {
      if (element.id === product.id) {
        element = product
      }

      return element;
    })
    setProducts(newProducts);
  }

  const deleteComplect = (id: number) => {
    let newProducts = products.filter(element => element.id != id)

    setProducts(newProducts);
  }

  const onEmitFields = (value: object | null = null) => {
    setStateFields(value);
  }

  const uploadPhoto = (addPhotos: Array<object>) => {
    setPhotos(addPhotos)
  }

  return (
    <div>
      <HeaderVirt use_products={products} stateFields={stateFields} photos={photos} />
      <Box sx={{mx: 4}}>
        <SearchField onEmitProduct={onEmitProduct} use_products={products} />
      </Box>
      {products.length > 0 &&
        <TableProductsVirtual products={products} onEmitCount={onEmitCount} deleteComplect={deleteComplect} />
      }
      {products.reduce((acc, item) => acc = acc + Number(item.count), 0) > 1 &&
      <Box sx={{mx: 4, mt: 4}}>
        <ProductFields onEmitFields={onEmitFields} uploadPhoto={uploadPhoto} products={products} />
      </Box>
      }
    </div>
  ) 
}

export default PageVirtualComplect
